(function(){

  /**
   * Component containing all of the content for the student standards tab
   */
  angular.module('edxComponents')
    .component('edxStudentStandardsView', {
      templateUrl: '/resources/components/standards-completion/student-standards-view.component/student-standards-view.component.html',
      controller: [
        '$state',
        'customer',
        '$scope',
        'edxReportItemService',
        'studentApi',
        'authentication',
        'edxDateTimeService',
        'configuration',
        StudentStandardsViewController],
      controllerAs: 'vm',
      bindings: {
        breadcrumbs: '=',
        hidePrint: '@edxHidePrint',
        hideExport: '@edxHideExport',
      }
    });

  function StudentStandardsViewController(
    $state,
    customer,
    $scope,
    reportItemService,
    studentApi,
    authentication,
    dateTimeService,
    configuration) {
    var vm = this;

    vm.getDistrictId = getDistrictId;
    vm.getUserId = getUserId;
    vm.getAstName = getAstName;
    vm.isPrintEnabled = isPrintEnabled;
    vm.isExportEnabled = isExportEnabled;
    vm.areAfButtonsEnabled = areAfButtonsEnabled;
    vm.dayOfWeek = dayOfWeek;

    vm.$onInit = $onInit;
    vm.$onChanges = $onChanges;
    vm.$onDestroy = $onDestroy;

    var itemSub; // Save subscription for cleanup

    function $onInit() {
      $scope.breadcrumbs = vm.breadcrumbs;
      $scope.$watch(function(){
        return getDistrictId() + '-' + getUserId() + '-' + getAstName();
      }, _refresh);

      // Get item for Print and Export analytics
      itemSub = reportItemService.getCurrentItemObservable().subscribe(function(item){
        if (vm.item !== item) {
          vm.item = item;
        }
      });
    }

    function $onDestroy() {
      itemSub.dispose();
    }

    function $onChanges(changes) {
      if (changes.breadcrumbs) {
        $scope.breadcrumbs = vm.breadcrumbs;
      }
    }

    function _refresh() {
      vm.studentStandardsExportUrl = studentApi.getStudentStandardsExportUrl();
      vm.refreshDate = new Date();
    }

    /**
     * Get districtId from state params.
     *
     * @return {number|string}
     */
    function getDistrictId() {
      if ($state.params.districtId === '-1') {
        return $state.params.studentDistrictId;
      } else {
        return $state.params.districtId;
      }
    }

    /**
     * Get userId from state params.
     *
     * @return {number}
     */
    function getUserId() {
      return $state.params.studentId;
    }

    /**
     * Get AST name from customer settings.
     *
     * @return {*}
     */
    function getAstName() {
      if (customer.getAcademicStandard()) {
        return customer.getAcademicStandard().academic_standard_name;
      } else {
        return undefined;
      }
    }

    /**
     * Determines if print button should be shown.
     *
     * @return {boolean}
     */
    function isPrintEnabled() {
      return _.isUndefined(vm.hidePrint) || vm.hidePrint === 'false';
    }

    /**
     * Determines if export button should be shown.
     *
     * @return {boolean}
     */
    function isExportEnabled() {
      return _.isUndefined(vm.hideExport) || vm.hideExport === 'false';
    }

    /**
     * Returns 3 character abbreviation for the day of the week, or "Today" if date is today
     *
     * @param date
     * @return {string}
     */
    function dayOfWeek(date) {
      return dateTimeService.dayOfWeekOrToday(date);
    }

    /**
     * Determines if Assign Focus buttons should be shown.
     *
     * @return {boolean}
     */
    function areAfButtonsEnabled() {
      if (configuration.isFeatureEnabled('dbl_lite')) {
        return false;
      }

      var authCustomer = authentication.getCustomer();
      if (!authentication.canAssignLessons(authCustomer)) {
        return false; // This customer can never make assignments
      }

      if ($state.current.name !== 'guardian') {
        return true; // Customer must be a teacher/admin so allow assignments
      }

      // Either the student is a home user or the guardian is tagged to make assignments for school students
      return $state.params.studentDistrictId === '-1' || authCustomer.hasTag('ASSIGN_FOCUS_ENABLED');
    }

  }
})();
